/** @format */

import axios, { AxiosRequestConfig } from 'axios';
import customToast, { ToastType } from '../components_/Toast';
import { logUserOut } from '../utils/logUserOut';
import { baseUrl_ } from '../utils/constants';

const Request = axios.create({
  baseURL: baseUrl_,
  timeout: 30000,
});

const requestConfiguration: any = (config: AxiosRequestConfig) => {
  /**
   * if user chooses to be remembered pull from local storage else
   * pull from session storage for consequent request
   */
  const token = localStorage.getItem('login-token');
  const sessId = localStorage.getItem('sessId');

  // don't append token for this routes
  if (token) {
    return {
      ...config,
      headers: {
        Authorization: `Bearer ${token}`,
        sessId: sessId,
        ...config.headers,
      },
    };
  }
  return config;
};

Request.interceptors.request.use(requestConfiguration, (error) => {
  // Do something with request error
  return Promise.reject(error);
});

Request.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      if (error.response.data.status === 593) {
        customToast('Your session has expired, please log in again', ToastType.error);
        setTimeout(() => {
          logUserOut(593);
        }, 500);
      }
    }
    return Promise.reject(error);
  },
);

export { Request };
